import { render, staticRenderFns } from "./history_EditUser.vue?vue&type=template&id=733109d2&scoped=true&"
import script from "./history_EditUser.vue?vue&type=script&lang=js&"
export * from "./history_EditUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733109d2",
  null
  
)

export default component.exports